import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Package } from "lucide-react";

export default function PacksPage() {
  const [packs, setPacks] = useState([]);
  const [details, setDetails] = useState({});

  useEffect(() => {
    api.get("/packs").then(async (r) => {
      setPacks(r.data);
      const all = {};
      for (const p of r.data) {
        try { all[p.slug] = (await api.get(`/packs/${p.slug}`)).data; } catch {}
      }
      setDetails(all);
    });
  }, []);

  return (
    <div className="p-6 lg:p-10 max-w-5xl">
      <div className="text-xs txt-mono uppercase tracking-widest text-muted-foreground">Engine</div>
      <h1 className="text-3xl font-semibold tracking-tight mt-1">Vertical Packs</h1>
      <p className="text-sm text-muted-foreground mt-1 mb-8">
        Each pack ships taxonomy, personas, prompts, CTAs, compliance rules and HTML templates.
        Adding a new niche = adding a new pack JSON — no core code changes.
      </p>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {packs.map((p) => {
          const d = details[p.slug] || {};
          return (
            <article key={p.slug} className="border border-border bg-card p-5">
              <div className="flex items-start gap-3 mb-3">
                <div className="w-9 h-9 grid place-items-center bg-primary/15 text-primary rounded-sm shrink-0">
                  <Package className="w-4 h-4" />
                </div>
                <div className="flex-1">
                  <h3 className="text-lg font-semibold">{p.name}</h3>
                  <div className="text-xs text-muted-foreground">{p.tagline || p.vertical}</div>
                </div>
                <span className="text-[10px] txt-mono uppercase border border-emerald-700/60 text-emerald-400 px-2 py-0.5 rounded-sm">
                  Available
                </span>
              </div>
              <div className="grid grid-cols-3 gap-2 mb-4">
                <div className="border border-border px-2 py-2">
                  <div className="text-[10px] txt-mono uppercase text-muted-foreground">Services</div>
                  <div className="stat-num">{p.services_count}</div>
                </div>
                <div className="border border-border px-2 py-2">
                  <div className="text-[10px] txt-mono uppercase text-muted-foreground">Personas</div>
                  <div className="stat-num">{p.personas_count}</div>
                </div>
                <div className="border border-border px-2 py-2">
                  <div className="text-[10px] txt-mono uppercase text-muted-foreground">Risk</div>
                  <div className="stat-num">{d.risk_level || "—"}</div>
                </div>
              </div>
              {d.services && (
                <div className="mb-3">
                  <div className="text-[10px] txt-mono uppercase tracking-widest text-muted-foreground mb-1">Services included</div>
                  <div className="flex flex-wrap gap-1">
                    {d.services.slice(0, 12).map((s) => (
                      <span key={s.slug} className="text-[10px] txt-mono border border-border px-1.5 py-0.5 rounded-sm">
                        {s.name}
                      </span>
                    ))}
                  </div>
                </div>
              )}
              {d.thread_types && (
                <div>
                  <div className="text-[10px] txt-mono uppercase tracking-widest text-muted-foreground mb-1">Thread intents</div>
                  <div className="flex flex-wrap gap-1">
                    {d.thread_types.map((t) => (
                      <span key={t.id} className="text-[10px] txt-mono text-muted-foreground border border-border px-1.5 py-0.5 rounded-sm">
                        {t.label}
                      </span>
                    ))}
                  </div>
                </div>
              )}
            </article>
          );
        })}
        <div className="border border-dashed border-border p-5 flex flex-col justify-center items-start">
          <div className="text-xs txt-mono uppercase tracking-widest text-muted-foreground mb-2">Coming next</div>
          <ul className="text-sm text-muted-foreground space-y-1">
            <li>· Financial Services (Debt, Credit Repair, Tax Relief)</li>
            <li>· Insurance (YMYL, with manual approval gate)</li>
            <li>· AI Companion</li>
            <li>· iGaming &amp; Crypto</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
